import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Marquee from "../components/Marquee";
import Services from "../sections/Services";
import Portfolio from "../sections/Portfolio";
import Process from "../sections/Process";
import Stats from "../sections/Stats";
import Testimonials from "../sections/Testimonials";
import EnquirySection from "../sections/EnquirySection";
import { scrollToId } from "../data/projects";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 300);
    }
  }, [location.hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <Process />
      <Stats />
      <Testimonials />
      <EnquirySection />
    </main>
  );
}
